import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import required modules
import { Autoplay } from 'swiper/modules';

const AboutUs = () => {
	const [pdfFile, setPdfFile] = useState(null);
	
	useEffect(() => {
		const href = window.location.href.substring(
			window.location.href.lastIndexOf("#") + 1
		);
		const element = document.getElementById(href);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
		
		// For demo purposes, you can replace this with your actual PDF URL
		setPdfFile("/path/to/your/document.pdf");
	}, []);
	
	return (
		<div className="w-full font-Open-sans mt-28">
			{/* Your existing About Us content */}
			<div className="w-full max-w-6xl mx-auto py-14 px-4 lg:px-0">
				<div className="w-full">
					<h2 className="text-4xl leading-tight sm:leading-normal sm:text-5xl font-bold mb-6 md:mb-10 relative lg:before:w-[12%] before:w-[30%] before:absolute before:h-1 before:bg-primary-500 before:-bottom-1 before:left-0">About Us</h2>
					<p className="md:text-lg mb-5 text-justify lg:text-left">SELC embodies the ethos of DAU by addressing critical global challenges, such as reducing carbon emissions, enhancing energy efficiency, and driving innovation in green technologies. Through its multidisciplinary approach, SELC empowers students, researchers, and faculty to collaborate on groundbreaking projects that integrate IoT, AI, and advanced analytics with energy systems.</p>
					<p className="md:text-lg text-justify lg:text-left">From optimizing battery utilization in renewable setups to real-time infrastructure monitoring in industrial environments, SELC's projects exemplify how research can directly contribute to societal progress. These initiatives not only align with global sustainability goals but also position DAU as a leader in climate action and energy innovation.</p>
				</div>
				<div id="vision-mission" className="w-full pt-40">
					<h2 className="text-4xl leading-tight sm:leading-normal sm:text-5xl font-bold mb-6 md:mb-10 relative lg:before:w-[12%] before:w-[30%] before:absolute before:h-1 before:bg-primary-500 before:-bottom-1 before:left-0">Vision & Mission</h2>
				</div>
				<div className="w-full py-6 flex flex-col md:flex-row items-start gap-10">
					<div className="w-full md:w-[30%] min-h-[600px] h-[600px] max-h-[600px] overflow-hidden rounded-xl">
						<div className="relative w-full overflow-hidden h-[40%]">
							<img src="https://images.pexels.com/photos/189349/pexels-photo-189349.jpeg?auto=compress&cs=tinysrgb&w=1080" alt="" className="w-full h-full object-cover" />
							<div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
								<p className="text-white text-4xl font-bold">Vision</p>
							</div>
						</div>
						<div className="w-full p-5 bg-gradient-to-t from-[#F1F1F1] to-[#FFFFFF] h-[60%] flex flex-col justify-center relative">
							<div className="bg-[#FFFFFF] rounded-full p-6 flex items-center justify-center absolute -top-[25%] left-1/2 transform -translate-x-1/2 translate-y-1/2">
								{/* Vision SVG */}
								<svg
									height="50px"
									width="50px"
									xmlns="http://www.w3.org/2000/svg"
									x="0px"
									y="0px"
									viewBox="0 0 512 512"
								>
									{/* SVG paths preserved */}
									<g>
										<g>
										<path d="M509.778,250.021C505.152,244.672,394.926,118.857,256,118.857S6.848,244.672,2.222,250.03 c-2.962,3.429-2.962,8.521,0,11.95C6.848,267.328,117.074,393.143,256,393.143S505.152,267.328,509.778,261.97 C512.741,258.542,512.741,253.449,509.778,250.021z M21.568,256c16.64-17.481,69.477-69.019,138.862-98.158 c-25.6,24.923-41.573,59.694-41.573,98.158c0,38.464,15.973,73.234,41.573,98.158C91.045,325.02,38.208,273.481,21.568,256z  M256,374.857c-65.536,0-118.857-53.321-118.857-118.857S190.464,137.143,256,137.143S374.857,190.464,374.857,256 S321.536,374.857,256,374.857z M351.579,354.158c25.591-24.923,41.563-59.694,41.563-98.158c0-38.464-15.973-73.234-41.573-98.158 c69.385,29.138,122.222,80.677,138.862,98.158C473.792,273.481,420.965,325.02,351.579,354.158z" />
										</g>
									</g>
									{/* Remaining SVG code preserved */}
								</svg>
							</div>
							<p className="md:text-lg text-justify lg:text-center">To revolutionize the global energy landscape and pave the way for a smart, energy-efficient, and carbon-neutral future.</p>
						</div>
					</div>
					<div className="w-full md:w-[30%] min-h-[600px] h-[600px] max-h-[600px] overflow-hidden rounded-xl">
						<div className="relative w-full overflow-hidden h-[40%]">
							<img src="https://images.pexels.com/photos/1001682/pexels-photo-1001682.jpeg?auto=compress&cs=tinysrgb&w=1080" alt="" className="w-full h-full object-cover" />
							<div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
								<p className="text-white text-4xl font-bold">Mission</p>
							</div>
						</div>
						<div className="w-full p-5 bg-gradient-to-t from-[#F1F1F1] to-[#FFFFFF] h-[60%] flex flex-col justify-center relative">
							<div className="bg-[#FFFFFF] rounded-full p-6 flex items-center justify-center absolute -top-[25%] left-1/2 transform -translate-x-1/2 translate-y-1/2">
								{/* Mission SVG */}
								<svg
									fill="#000000"
									width="50px"
									height="50px"
									viewBox="0 0 36 36"
									preserveAspectRatio="xMidYMid meet"
								>
									{/* SVG paths preserved */}
									<path
										d="M18,2a15.92,15.92,0,0,0-4.25.59l.77,1.86a14.07,14.07,0,1,1-10,10l-1.86-.78A16,16,0,1,0,18,2Z"
										className="clr-i-outline clr-i-outline-path-1"
									/>
									<path
										d="M7.45,15.7a10.81,10.81,0,1,0,8.3-8.26L16.37,9A9.24,9.24,0,1,1,9,16.32Z"
										className="clr-i-outline clr-i-outline-path-2"
									/>
									<path
										d="M18,22.09a4.08,4.08,0,0,1-4-3.68l-1.63-.68c0,.09,0,.18,0,.27A5.69,5.69,0,1,0,18,12.31h-.24L18.43,14A4.07,4.07,0,0,1,18,22.09Z"
										className="clr-i-outline clr-i-outline-path-3"
									/>
									<path
										d="M8.2,13.34a.5.5,0,0,0,.35.15H12.2l5.37,5.37A1,1,0,0,0,19,17.44L13.53,12V8.51a.5.5,0,0,0-.15-.35L7.79,2.57a.5.5,0,0,0-.85.35v4H3a.5.5,0,0,0-.35.85Z"
										className="clr-i-outline clr-i-outline-path-4"
									/>
									<rect x={0} y={0} width={36} height={36} fillOpacity={0} />
								</svg>
							</div>
							<p className="md:text-lg text-justify lg:text-center">To drive transformative solutions in sustainable energy by fostering interdisciplinary collaboration, advancing cutting-edge research, and building strong partnerships that empower stakeholders toward a smarter, energy-efficient, and carbon-neutral world.</p>
						</div>
					</div>
				</div>
				
				{/* PDF Viewer Section */}
				<div id="documents" className="w-full pt-40">
					<h2 className="text-4xl leading-tight sm:leading-normal sm:text-5xl font-bold mb-6 md:mb-10 relative lg:before:w-[12%] before:w-[30%] before:absolute before:h-1 before:bg-primary-500 before:-bottom-1 before:left-0">Documents</h2>
					<div className="w-full py-6">
						<PDFViewer pdfFile={pdfFile} />
					</div>
				</div>
			</div>
		</div>
	);
};

// PDF Viewer Component
const PDFViewer = ({ pdfFile }) => {
	const [loading, setLoading] = useState(true);
	
	useEffect(() => {
		// Simulate loading
		if (pdfFile) {
			const timer = setTimeout(() => {
				setLoading(false);
			}, 1000);
			
			return () => clearTimeout(timer);
		}
	}, [pdfFile]);
	
	if (!pdfFile) {
		return (
			<div className="w-full h-96 bg-gray-100 rounded-lg flex items-center justify-center">
				<p className="text-gray-500">No document available</p>
			</div>
		);
	}
	
	return (
		<div className="w-full">
			<div className="mb-4 flex justify-between items-center ">
				<h3 className="text-xl font-semibold">SELC Documentation</h3>
				<a 
					href={'/pdf/SELC Booklet.pdf'}
					download 
					className="px-4 py-2 bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-colors flex items-center"
				>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
					</svg>
					Download PDF
				</a>
			</div>
			
			<div className="w-full h-[60vh] md:h-[80vh] bg-gray-100 rounded-lg overflow-hidden">
				{loading ? (
					<div className="w-full h-full flex items-center justify-center">
						<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
					</div>
				) : (
					<iframe
						src={`${'/pdf/SELC Booklet.pdf'}#view=FitH`}
						className="w-full h-full"
						title="PDF Viewer"
					/>
				)}
			</div>
			
			{/* PDF Controls */}
			{/* <div className="mt-4 flex justify-between items-center bg-gray-100 p-4 rounded-lg">
				<div className="flex items-center space-x-4">
					<button className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
						</svg>
					</button>
					<span className="text-gray-700">Page <span className="font-semibold">1</span> of <span className="font-semibold">10</span></span>
					<button className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
						</svg>
					</button>
				</div>
				
				<div className="flex items-center space-x-4">
					<button className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
						</svg>
					</button>
					<button className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" />
						</svg>
					</button>
				</div>
			</div> */}
		</div>
	);
};

export default AboutUs;